exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-block[data-v-086a761a]{font-size:15px}.info-block_field[data-v-086a761a]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center}.info-block_field__label[data-v-086a761a]{margin-right:10px}.info-block_field__value[data-v-086a761a]{font-weight:600;padding:3px 0}.info-block .action_link[data-v-086a761a]{border:none;background:none;padding:3px 0;font-weight:600;color:#6e6bce;cursor:pointer;-webkit-text-decoration-line:none;text-decoration-line:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-086a761a","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/resultCourses/components/InfoBlock.vue
// module id = d324d1ecd2e44aac5999
// module chunks = 23